import { Lock } from 'lucide-react';
import type { RecordStatus } from '../../types/induction';
import { STATUS_CLASSES, STATUS_LABELS } from './inductionLabels';
import { cn } from '../../utils/cn';

export function InductionSkeleton() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <div className="h-8 bg-neutral-100 rounded animate-pulse w-64 max-w-full mb-4" />
      <div className="h-40 bg-neutral-100 rounded animate-pulse" />
    </div>
  );
}

export function InductionAccessDenied() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="bg-white border border-neutral-200 rounded-xl p-6 sm:p-8 text-center">
        <Lock className="h-10 w-10 text-neutral-300 mx-auto mb-3" />
        <h2 className="text-lg font-semibold text-neutral-800 mb-1">A supervisor or HR seat is required</h2>
        <p className="text-sm text-neutral-500 mb-4 break-words">
          The induction register needs a <span className="font-medium">Farm Jobs supervisor or admin</span> seat,
          a <span className="font-medium">Vehicles creator or admin</span> seat, or a{' '}
          <span className="font-medium">Timesheet HR</span> seat.
        </p>
        <p className="text-xs text-neutral-400">
          Your own inductions are under Inductions on the dashboard. Your organisation admin can assign seats on the Subscriptions page.
        </p>
      </div>
    </div>
  );
}

export function StatusBadge({ status, className }: { status: RecordStatus; className?: string }) {
  return (
    <span className={cn('inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-xs font-medium', STATUS_CLASSES[status], className)}>
      {STATUS_LABELS[status]}
    </span>
  );
}
